import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Drawer, Hidden, Divider} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import {NavLink} from 'react-router-dom';
import ListItem from "@material-ui/core/ListItem/ListItem";
import {connect} from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import './sidebar.css';
import {logoutAction, userCheckOutWithLogout} from '../../../Actions/index';
import {routeName} from '../../../../src/Service/env';
import {bindActionCreators} from 'redux';
import {audioFunc} from "../../../Service/helper";

const drawerWidth = 200;
const drawerHeight = '100%';

const styles = theme => ({
    drawerPaper: {
        backgroundColor: '#f5f5f5',
        zIndex: '1',
        width: drawerWidth,
        height: drawerHeight,
        [theme.breakpoints.up('lg')]: {
            position: 'relative',
        },
        maxHeight: "100vh",
        overflowY: "auto",
        // borderRight: "none",
        scrollbarWidth: "none",
    },
    toolbar: theme.mixins.toolbar,

    subheading: {
        fontSize: '0.7em',
        fontWeight: '500',
        '&:active': {
            color: '#e13d43'
        },
        color: 'rgba(0, 0, 0, 0.87)',
        lineHeight: '1.5em',
    },
    curbsideCommunicationText: {
        padding: '12px 6px 12px 23px !important'
    },
    curbsideCommunication: {
        padding: '0px 0px 0px 0px'
    }
});

const StarterKitToolTip = withStyles(() => ({
    tooltip: {
        backgroundColor: '#851679',
        margin: '0px 0px 0px 100px',
        color: 'white',
        maxWidth: 220,
        fontSize: '16px',
        border: '1px solid #dadde9',
    },
}))(Tooltip);

class Sidebar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: "Overview",
        }
    }

    changeTab = (tab) => () => {

        audioFunc(true, false, '')

        this.setState({
            activeTab: tab
        });

        localStorage.removeItem('curbsideCommunicationUserId');
        localStorage.removeItem('curbsideCommunicationUserName');
        localStorage.removeItem('curbsideCommunicationFullName');
        localStorage.removeItem('curbsideCommunicationProfileImage');
        this.props.toggle();
    };

    componentDidMount() {
        this.setState({
            activeTab: this.props.route.location.pathname.split("/")[this.props.route.location.pathname.split("/").length - 1]
        })
    }

    handleDrawerToggle = () => {
        this.props.toggle();
    }

    render() {
        const {classes, theme} = this.props;
        let activeTab
        activeTab = this.props.route.location.pathname.split("/")[this.props.route.location.pathname.split("/").length - 1];
        let count = this.props.messageData && this.props.messageData.unreadCount;
        let appointmentFormId = this.props.user.BusinessUser.AppointmentFormId;
        let isItRestaurant = this.props.user.BusinessUser.IsItRestaurant;
        let onlineOrderFormId = this.props.user.BusinessUser.OnlineOrderFormId;
        let onlineOrderFormType = this.props.user.BusinessUser.OnlineOrderFormType;
        return (
            <div>
                <Hidden lgUp>
                    <Drawer
                        open={this.props.mobileOpen}
                        onClose={this.handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                        variant="temporary"
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <div className={classes.toolbar}/>
                        <List className="nav">
                            <ListItem className={(activeTab === "Overview") ? "link-overview-blue" : ""}
                                      onClick={this.changeTab("Overview")}>
                                <NavLink to={`/${routeName}/Dashboard/Overview`}><ListItemText primary="Overview"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                            </ListItem>
                        </List>
                        <Divider/>
                        <List className="nav">
                            <ListItem className={(activeTab === "CurbsideCommunication") ? "link-heatspot-orange" : ""}
                                      onClick={this.changeTab("CurbsideCommunication")}>
                                <NavLink to={`/${routeName}/Dashboard/CurbsideCommunication`}
                                         className={classes.curbsideCommunicationText}>
                                    <ListItemText primary="Curbside Communication"
                                                  classes={{root: classes.curbsideCommunication}}
                                                  primaryTypographyProps={{
                                                      className: classes.subheading
                                                  }}/>
                                </NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Messages") ? "link-message-red" : ""}
                                      onClick={this.changeTab("Messages")}>
                                <NavLink to={`/${routeName}/Dashboard/Messages`}><ListItemText primary="My Messages"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                                {count > 0 && <span className="message-badge badge">{count}</span>}
                            </ListItem>
                            {appointmentFormId !== null && appointmentFormId !== "" &&
                            isItRestaurant ?
                                <ListItem
                                    className={(activeTab === "Reservations") ? "link-appointment-royalPurple" : ""}
                                    onClick={this.changeTab("Reservations")}>
                                    <NavLink to={`/${routeName}/Dashboard/Reservations`}><ListItemText
                                        primary="Reservations"
                                        primaryTypographyProps={{
                                            className: classes.subheading
                                        }}/></NavLink>
                                </ListItem>
                                : appointmentFormId !== null && appointmentFormId !== "" ?
                                    <ListItem
                                        className={(activeTab === "Appointments") ? "link-appointment-royalPurple" : ""}
                                        onClick={this.changeTab("Appointments")}>
                                        <NavLink to={`/${routeName}/Dashboard/Appointments`}><ListItemText
                                            primary="My Appointments"
                                            primaryTypographyProps={{
                                                className: classes.subheading
                                            }}/></NavLink>
                                    </ListItem> : ""
                            }
                            {onlineOrderFormId !== null && onlineOrderFormId !== "" &&
                            <div className="nav">
                                <ListItem className={(activeTab === "Orders") ? "link-order-cyangreen" : ""}
                                          onClick={this.changeTab("Orders")}>
                                    <NavLink to={`/${routeName}/Dashboard/Orders`}><ListItemText primary="Orders"
                                                                                                 primaryTypographyProps={{
                                                                                                     className: classes.subheading
                                                                                                 }}/></NavLink>
                                </ListItem>
                                {onlineOrderFormType !== null && onlineOrderFormType !== "" && onlineOrderFormType !== "jotform" &&
                                <div className="nav">
                                    <ListItem
                                        className={(activeTab === "OrderNotifications") ? "link-orderNotifications-deepBlush" : ""}
                                        onClick={this.changeTab("OrderNotifications")}>
                                        <NavLink to={`/${routeName}/Dashboard/OrderNotifications`}><ListItemText
                                            primary="Order Notifications"
                                            primaryTypographyProps={{
                                                className: classes.subheading
                                            }}/></NavLink>
                                    </ListItem>
                                    <ListItem className={(activeTab==="Menu") ? "link-menuItems-cerulean" : ""} onClick={this.changeTab("Menu")}>
                                        <a href = "https://www.ubmefood.com/menuedit" target = "_blank"
                                           rel = "noopener noreferrer"><ListItemText
                                            primary="Menu"
                                            primaryTypographyProps={{
                                                className: classes.subheading
                                            }}/></a>
                                        {/*<NavLink to={`/${routeName}/Dashboard/Menu`}><ListItemText primary="Menu"*/}
                                        {/*                                                           primaryTypographyProps={{*/}
                                        {/*                                                               className: classes.subheading*/}
                                        {/*                                                           }}/></NavLink>*/}
                                    </ListItem>
                                </div>
                                }
                            </div>
                            }
                            {/*<ListItem>*/}
                            {/*<a style={{display: 'flex'}} href="https://www.ubme.com/wp-content/uploads/2020/05/Starter-Kit.pdf" target="_blank">*/}
                            {/*    <ListItemText*/}
                            {/*        primary="Starter Kit"*/}
                            {/*        primaryTypographyProps={{*/}
                            {/*            className: classes.subheading*/}
                            {/*        }}*/}
                            {/*    />*/}
                            {/*    <StarterKitToolTip title={*/}
                            {/*        <React.Fragment>Click here for information on how to use UBMe!</React.Fragment>*/}
                            {/*    }>*/}
                            {/*        <IconButton style={{height: '24px', color: '#851679', margin: '-2px 25px 0px 0px', width: '0px'}}>*/}
                            {/*                <InfoIcon/>*/}
                            {/*        </IconButton>*/}
                            {/*    </StarterKitToolTip>*/}
                            {/*</a>*/}
                            {/*</ListItem>*/}
                        </List>
                        <Divider className="line"/>
                        <List className="nav">
                            <ListItem className={(activeTab === "Deal") ? "link-deal-pink" : ""}
                                      onClick={this.changeTab("Deal")}>
                                <NavLink to={`/${routeName}/Dashboard/Deal`}><ListItemText primary="In-Store Deals"
                                                                                           primaryTypographyProps={{
                                                                                               className: classes.subheading
                                                                                           }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Posts") ? "link-post-lightgreen" : ""}
                                      onClick={this.changeTab("Posts")}>
                                <NavLink to={`/${routeName}/Dashboard/Posts`}><ListItemText primary="My Local Posts"
                                                                                            primaryTypographyProps={{
                                                                                                className: classes.subheading
                                                                                            }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Events") ? "link-event-skyblue" : ""}
                                      onClick={this.changeTab("Events")}>
                                <NavLink to={`/${routeName}/Dashboard/Events`}><ListItemText primary="My Local Events"
                                                                                             primaryTypographyProps={{
                                                                                                 className: classes.subheading
                                                                                             }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Album") ? "link-album-maroon" : ""}
                                      onClick={this.changeTab("Album")}>
                                <NavLink to={`/${routeName}/Dashboard/Album`}><ListItemText primary="My Album"
                                                                                            primaryTypographyProps={{
                                                                                                className: classes.subheading
                                                                                            }}/></NavLink>
                            </ListItem>
                        </List>
                        <Divider className="line"/>
                        <List className="nav">
                            <ListItem className={(activeTab === "Visitors") ? "link-visitor-yellow" : ""}
                                      onClick={this.changeTab("Visitors")}>
                                <NavLink to={`/${routeName}/Dashboard/Visitors`}><ListItemText primary="Visitors"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Activity") ? "link-activity-parrotgreen" : ""}
                                      onClick={this.changeTab("Activity")}>
                                <NavLink to={`/${routeName}/Dashboard/Activity`}><ListItemText primary="Activity"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "MyAccount") ? "link-account-lightblue" : ""}
                                      onClick={this.changeTab("MyAccount")}>
                                <NavLink to={`/${routeName}/Dashboard/MyAccount`}><ListItemText primary="My Account"
                                                                                                primaryTypographyProps={{
                                                                                                    className: classes.subheading
                                                                                                }}/></NavLink>
                            </ListItem>
                        </List>
                        <Divider className="line"/>
                        <List className="nav" style={{paddingBottom: '450px'}}>
                            <ListItem onClick={() => {
                                let data = {
                                    GooglePlaceId: this.props.user.BusinessUser.PlaceID,
                                    UserId: this.props.user.AppUser.UserId
                                };
                                this.props.userCheckOutWithLogout(data);
                            }}>
                                <NavLink to={'#'}>
                                    <ListItemText primary="Logout"
                                                  style={{color: 'red'}}
                                                  primaryTypographyProps={{
                                                      className: classes.subheading
                                                  }}
                                    /></NavLink>
                            </ListItem>
                        </List>
                    </Drawer>
                </Hidden>
                <Hidden mdDown implementation="css">
                    <Drawer
                        variant="permanent"
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <div className={classes.toolbar}/>
                        <List className="nav">
                            <ListItem className={(activeTab === "Overview") ? "link-overview-blue" : ""}
                                      onClick={this.changeTab("Overview")}>
                                <NavLink to={`/${routeName}/Dashboard/Overview`}><ListItemText primary="Overview"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                            </ListItem>
                        </List>
                        <Divider/>
                        <List className="nav">
                            <ListItem className={(activeTab === "CurbsideCommunication") ? "link-heatspot-orange" : ""}
                                      onClick={this.changeTab("CurbsideCommunication")}>
                                <NavLink to={`/${routeName}/Dashboard/CurbsideCommunication`}
                                         className={classes.curbsideCommunicationText}>
                                    <ListItemText primary="Curbside Communication"
                                                  classes={{root: classes.curbsideCommunication}}
                                                  primaryTypographyProps={{
                                                      className: classes.subheading
                                                  }}
                                    />
                                </NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Messages") ? "link-message-blue" : ""}
                                      onClick={this.changeTab("Messages")}>
                                <NavLink to={`/${routeName}/Dashboard/Messages`}><ListItemText primary="My Messages"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                                {count > 0 && <span className="message-badge badge">{count}</span>}
                            </ListItem>
                            {appointmentFormId !== null && appointmentFormId !== "" &&
                            isItRestaurant ?
                                <ListItem
                                    className={(activeTab === "Reservations") ? "link-appointment-royalPurple" : ""}
                                    onClick={this.changeTab("Reservations")}>
                                    <NavLink to={`/${routeName}/Dashboard/Reservations`}><ListItemText
                                        primary="Reservations"
                                        primaryTypographyProps={{
                                            className: classes.subheading
                                        }}/></NavLink>
                                </ListItem>
                                : appointmentFormId !== null && appointmentFormId !== "" ?
                                    <ListItem
                                        className={(activeTab === "Appointments") ? "link-appointment-royalPurple" : ""}
                                        onClick={this.changeTab("Appointments")}>
                                        <NavLink to={`/${routeName}/Dashboard/Appointments`}><ListItemText
                                            primary="My Appointments"
                                            primaryTypographyProps={{
                                                className: classes.subheading
                                            }}/></NavLink>
                                    </ListItem> : ""
                            }
                            {onlineOrderFormId !== null && onlineOrderFormId !== "" &&
                            <div className="nav">
                                <ListItem className={(activeTab === "Orders") ? "link-order-cyangreen" : ""}
                                          onClick={this.changeTab("Orders")}>
                                    <NavLink to={`/${routeName}/Dashboard/Orders`}>
                                        <ListItemText primary="Orders"
                                                      primaryTypographyProps={{
                                                          className: classes.subheading
                                                      }}/>
                                    </NavLink>
                                </ListItem>
                                {onlineOrderFormType !== null && onlineOrderFormType !== "" && onlineOrderFormType !== "jotform" &&
                                <div className="nav">
                                    <ListItem
                                        className={(activeTab === "OrderNotifications") ? "link-orderNotifications-deepBlush" : ""}
                                        onClick={this.changeTab("OrderNotifications")}>
                                        <NavLink to={`/${routeName}/Dashboard/OrderNotifications`}><ListItemText
                                            primary="Order Notifications"
                                            primaryTypographyProps={{
                                                className: classes.subheading
                                            }}/></NavLink>
                                    </ListItem>
                                    <ListItem className={(activeTab === "Menu") ? "link-menuItems-cerulean" : ""}
                                              onClick={this.changeTab("Menu")}>

                                        <a href = "https://www.ubmefood.com/menuedit" target = "_blank"
                                           rel = "noopener noreferrer"><ListItemText
                                            primary="Menu"
                                            primaryTypographyProps={{
                                                className: classes.subheading
                                            }}/></a>
                                        {/*<NavLink to={`/${routeName}/Dashboard/Menu`}><ListItemText primary="Menu"*/}
                                        {/*                                                           primaryTypographyProps={{*/}
                                        {/*                                                               className: classes.subheading*/}
                                        {/*                                                           }}/></NavLink>*/}
                                    </ListItem>
                                </div>
                                }
                            </div>
                            }
                            {/*<ListItem>*/}
                            {/*    <a style={{display: 'flex'}} href="https://www.ubme.com/wp-content/uploads/2020/05/Starter-Kit.pdf" target="_blank">*/}
                            {/*        <ListItemText*/}
                            {/*            primary="Starter Kit"*/}
                            {/*            primaryTypographyProps={{*/}
                            {/*                className: classes.subheading*/}
                            {/*            }}*/}
                            {/*        />*/}
                            {/*        <StarterKitToolTip title={*/}
                            {/*            <React.Fragment>Click here for information on how to use UBMe!</React.Fragment>*/}
                            {/*        }>*/}
                            {/*            <IconButton style={{height: '24px', color: '#851679', margin: '-2px 25px 0px 0px', width: '0px'}}>*/}
                            {/*                    <InfoIcon/>*/}
                            {/*            </IconButton>*/}
                            {/*        </StarterKitToolTip>*/}
                            {/*    </a>*/}
                            {/*</ListItem>*/}
                        </List>
                        <Divider className="line"/>
                        <List className="nav">
                            <ListItem className={(activeTab === "Deal") ? "link-deal-pink" : ""}
                                      onClick={this.changeTab("Deal")}>
                                <NavLink to={`/${routeName}/Dashboard/Deal`}><ListItemText primary="In-Store Deals"
                                                                                           primaryTypographyProps={{
                                                                                               className: classes.subheading
                                                                                           }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Posts") ? "link-post-lightgreen" : ""}
                                      onClick={this.changeTab("Posts")}>
                                <NavLink to={`/${routeName}/Dashboard/Posts`}><ListItemText primary="My Local Posts"
                                                                                            primaryTypographyProps={{
                                                                                                className: classes.subheading
                                                                                            }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Events") ? "link-event-skyblue" : ""}
                                      onClick={this.changeTab("Events")}>
                                <NavLink to={`/${routeName}/Dashboard/Events`}><ListItemText primary="My Local Events"
                                                                                             primaryTypographyProps={{
                                                                                                 className: classes.subheading
                                                                                             }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Album") ? "link-album-maroon" : ""}
                                      onClick={this.changeTab("Album")}>
                                <NavLink to={`/${routeName}/Dashboard/Album`}><ListItemText primary="My Album"
                                                                                            primaryTypographyProps={{
                                                                                                className: classes.subheading
                                                                                            }}/></NavLink>
                            </ListItem>
                        </List>
                        <Divider className="line"/>
                        <List className="nav">
                            <ListItem className={(activeTab === "Visitors") ? "link-visitor-yellow" : ""}
                                      onClick={this.changeTab("Visitors")}>
                                <NavLink to={`/${routeName}/Dashboard/Visitors`}><ListItemText primary="Visitors"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "Activity") ? "link-activity-parrotgreen" : ""}
                                      onClick={this.changeTab("Activity")}>
                                <NavLink to={`/${routeName}/Dashboard/Activity`}><ListItemText primary="Activity"
                                                                                               primaryTypographyProps={{
                                                                                                   className: classes.subheading
                                                                                               }}/></NavLink>
                            </ListItem>
                            <ListItem className={(activeTab === "MyAccount") ? "link-account-lightblue" : ""}
                                      onClick={this.changeTab("MyAccount")}>
                                <NavLink to={`/${routeName}/Dashboard/MyAccount`}><ListItemText primary="My Account"
                                                                                                primaryTypographyProps={{
                                                                                                    className: classes.subheading
                                                                                                }}/></NavLink>
                            </ListItem>
                        </List>
                        <Divider className="line"/>
                        <List className="nav" style={{paddingBottom: '450px'}}>
                            <ListItem onClick={() => {
                                let data = {
                                    GooglePlaceId: this.props.user.BusinessUser.PlaceID,
                                    UserId: this.props.user.AppUser.UserId
                                };
                                this.props.userCheckOutWithLogout(data);
                            }}>
                                <NavLink to={'#'}>
                                    <ListItemText primary="Logout"
                                                  style={{color: 'red'}}
                                                  primaryTypographyProps={{
                                                      className: classes.subheading
                                                  }}
                                    /></NavLink>
                            </ListItem>
                        </List>
                    </Drawer>
                </Hidden>
            </div>

        );
    };
}

Sidebar.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        user: state.loginResponse.results,
        messageData: state.messageReducer,
        route: state.router
    };
};

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        userCheckOutWithLogout,
        logoutAction
    }, dispatch);
};
export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, matchDispatchToProps)(Sidebar));